// extracted by mini-css-extract-plugin
export default {"component":"UserSelectorContent-module__component___E2gzX"};